/* Copyright (c) 2021-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

export enum SLAType {
  TTA = "TTA",
  TTR = "TTR",
  RANGE = "Range",
}

export enum SLAUnitType {
  VALUE_RANGE = "VALUE_RANGE",
  BEST_EFFORT = "BEST_EFFORT",
  CUSTOM = "CUSTOM",
}

export enum SLAPriority {
  P4 = "P4",
  P3 = "P3",
  P2 = "P2",
  P1 = "P1",
}

export enum SupportHours {
  NOT_APPLICABLE = "NOT_APPLICABLE",
  H8D5 = "8x5",
  H8D7 = "8x7",
  H24D5 = "24x5",
  H24D7 = "24x7",
}

export type Sla = {
  description: string;
  id: string;
  name: string;
  supportHours: SupportHours;
  slaType: string;
  unitType: string;
  range: Range;
  priority: string;
};

export type Range = {
  default: string;
  max: string;
  min: string;
  unit: string;
};
